import { _APP_DATA } from "@/data/AppData";

export const _URL_REGEX = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

// FIXME
export function _TimeToInputFmt(time = new Date()) {
    return time.getHours().toString().padStart(2, "0") + ":" + time.getMinutes().toString().padStart(2, "0");
}

// FIXME
export function _DateToInputFmt(time = new Date()) {
    return time.getFullYear() + "-" + (time.getMonth() + 1).toString().padStart(2, "0") + "-" + time.getDate().toString().padStart(2, "0");
}

export function _GetAppBuildTag() {
    // return "v" + import.meta.env.APP_VERSION_NAME;
    const appVersion = _APP_DATA.APP_VERSION;
    const uiVersion = import.meta.env.APP_VERSION_NAME;
    if (!appVersion) return `${uiVersion}`;
    else if (appVersion === uiVersion) return `${appVersion}`;
    return `app-${appVersion} - ui-${uiVersion}`;
}

/** Devuelve el valor con 2 decimales */
export function _BytesToMB(bytes: number): number {
    const MB = bytes / (1024 * 1024);
    return +MB.toFixed(2);
}